import React from 'react'
import FileItem from './../FileItem/FileItem'

const FileList = ({ uploadFiles, buildUrl, titlePreFix, removeFile }) => {
    let fileList
    if(buildUrl !== undefined){
        fileList =  titlePreFix == 'Edit' ? buildUrl : uploadFiles
    }
    const deleteFileHandler = (_name) => {
            removeFile(_name,"build")
    }
    return (
        <ul className="file-list">
            {
                fileList &&
                fileList.map(f => (<FileItem
                    key={f.name}
                    file={f}
                    deleteFile={deleteFileHandler} />))
            }
        </ul>
    )
}

export default FileList